module.exports = __webpack_public_path__ + "img/hr-chemical-plant.dfb4fb7f.png";